import "./ImageCollection.scss"

import IconCheckboxChecked from "assets/img/icon-checkbox-checked.svg"
import IconCheckboxUnchecked from "assets/img/icon-checkbox-unchecked.svg"

import React, { FunctionComponent } from "react"
import dayjs from "utils/dayjs"

import Text from "components/Text/Text"
import { Flex, FlexItem } from "components/Flex"
import { Grid } from "components/Grid"
import { useTranslation } from "react-i18next"
import ImageCollectionModel from "models/ImageCollection"
import Tag from "components/Tag/Tag"
import Button from "components/Button/Button"
import { Guid } from "@/types"

interface IImageCollectionProps {
    data: ImageCollectionModel
    info?: boolean
    tags?: boolean
    imageSelectMode?: boolean
    selectedImageIds?: Guid[]
    onImageClick(imageIndex: number): void
    onSelectAll?(): void
}

const ImageCollection: FunctionComponent<React.PropsWithChildren<IImageCollectionProps>> = ({
    data,
    info,
    tags,
    imageSelectMode,
    selectedImageIds,
    onImageClick,
    onSelectAll
}) => {
    const { t } = useTranslation()
    return (
        <div className="image-collection"
            data-testid="image-collection">
            {info &&
                <Flex
                    className="mb-2"
                    justifyContent="space-between"
                    alignItems="center">
                    <FlexItem>
                        <Flex>
                            <Text className="mr-2" type="h3">
                                {dayjs(data.collectionDate).format(t("config.dateLongTimeFormat"))}
                            </Text>
                            {imageSelectMode &&
                            <Button
                                theme='link'
                                label={t('common.selectAll')}
                                onClick={onSelectAll}
                                />}
                        </Flex>
                    </FlexItem>
                    <FlexItem>{t("common.xPictures", { count: data.images?.length || 0 })}</FlexItem>
                </Flex>
            }
            <Grid
                gap="8px"
                columns="repeat(4, 1fr)">
                {data?.images?.map((image, idx) => (
                    <Flex justifyContent="center"
                        alignItems="center"
                        key={idx}
                        data-testid="image-collection-image"
                        style={{ position: "relative" }}>
                        <button type="button" className="image-collection__image-box"
                            onClick={() => image?.imageUri && onImageClick(idx)}>
                            <img src={image.thumbnailUri} className="image-collection__image" alt="" />
                            {imageSelectMode && (
                                <img
                                    src={selectedImageIds?.includes(image.fileId) ? IconCheckboxChecked : IconCheckboxUnchecked}
                                    style={{
                                        position: "absolute",
                                        top: 4,
                                        right: 4,
                                        pointerEvents: "none",
                                    }}
                                />
                            )}
                        </button>
                    </Flex>
                ))}
            </Grid>
            {tags && !!data.tags && data.tags.length > 0 &&
                <Flex
                    className="mt-3"
                    wrap="wrap">
                    {data.tags.map((tag, idx) => (
                        <FlexItem key={idx} className="mb-1 mr-1 max-w-100">
                            <Tag label={tag} />
                        </FlexItem>
                    ))}
                </Flex>
            }
        </div>
    )
}

export default ImageCollection
